{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Automatiseringsregel toevoegen",
    "LOADING": "Automatiseringsregels ophalen",
    "ADD": {
      "TITLE": "Automatiseringsregel toevoegen",
      "SUBMIT": "Aanmaken",
      "CANCEL_BUTTON_TEXT": "Annuleren",
      "FORM": {
        "NAME": {
          "LABEL": "Regel naam",
          "PLACEHOLDER": "Voer regelnaam in",
          "ERROR": "Naam is vereist"
        },
        "DESC": {
          "LABEL": "Beschrijving",
          "PLACEHOLDER": "Voer regelomschrijving in",
          "ERROR": "Omschrijving is vereist"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Selecteer er een",
          "ERROR": "Event is verplicht"
        },
        "PHASE": {
          "LABEL": "Fase"
        },
        "ORDER": {
          "LABEL": "Volgorde",
          "ERROR": "Volgorde is vereist"
        },
        "CONDITIONS": {
          "LABEL": "Voorwaarden"
        },
        "ACTIONS": {
          "LABEL": "Acties"
        }
      },
      "CONDITION_BUTTON_LABEL": "Voorwaarde toevoegen",
      "ACTION_BUTTON_LABEL": "Actie toevoegen",
      "API": {
        "SUCCESS_MESSAGE": "Automatiseringsregel succesvol toegevoegd",
        "ERROR_MESSAGE": "Kan geen automatiseringsregel aanmaken, probeer het later opnieuw"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fase",
        "ORDER": "Volgorde",
        "NAME": "Naam",
        "DESCRIPTION": "Beschrijving",
        "ACTIVE": "Actief",
        "CREATED_ON": "Aangemaakt op",
        "WAIT": "Wachttijd"
      },
      "404": "Geen automatiseringsregels gevonden",
      "TABS": {
        "ALL": "Alle",
        "INSTANT": "Bij gebeurtenis",
        "DELAYED": "Vertraagd"
      },
      "WAITS": "Wacht {duration}"
    },
    "DELETE": {
      "TITLE": "Automatiseringsregel verwijderen",
      "SUBMIT": "Verwijderen",
      "CANCEL_BUTTON_TEXT": "Annuleren",
      "CONFIRM": {
        "TITLE": "Verwijderen bevestigen",
        "MESSAGE": "Weet u zeker dat u wilt verwijderen ",
        "YES": "Ja, verwijderen ",
        "NO": "Nee, Behouden "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatiseringsregel succesvol verwijderd",
        "ERROR_MESSAGE": "Kon geen automatiseringsregel verwijderen, probeer het later opnieuw"
      }
    },
    "EDIT": {
      "TITLE": "Automatiseringsregel bewerken",
      "SUBMIT": "Vernieuwen",
      "CANCEL_BUTTON_TEXT": "Annuleren",
      "API": {
        "SUCCESS_MESSAGE": "Automatiseringsregel succesvol bijgewerkt",
        "ERROR_MESSAGE": "Automatiseringsregel kon niet worden bijgewerkt, probeer het later opnieuw"
      }
    },
    "CLONE": {
      "TOOLTIP": "Kloon",
      "API": {
        "SUCCESS_MESSAGE": "Automatisering met succes gekloond",
        "ERROR_MESSAGE": "Automatiseringsregel kon niet worden gekloond, probeer het later opnieuw"
      }
    },
    "FORM": {
      "EDIT": "Bewerken",
      "CREATE": "Aanmaken",
      "DELETE": "Verwijderen",
      "CANCEL": "Annuleren",
      "RESET_MESSAGE": "Het veranderen van het event type zal de condities en events die u hieronder hebt toegevoegd resetten"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "U moet tenminste één voorwaarde hebben om op te slaan",
      "CONTACT_CUSTOM_ATTR_LABEL": "Aangepaste contactattributen",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Gesprek aangepaste attributen"
    },
    "ACTION": {
      "DELETE_MESSAGE": "U moet tenminste één actie hebben om op te slaan",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Voer hier uw bericht in",
      "TEAM_DROPDOWN_PLACEHOLDER": "Teams selecteren",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Selecteer de e-mailinbox en het afzenderadres",
      "SUBJECT_INPUT_PLACEHOLDER": "Onderwerp van de e-mail",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Selecteer de sms-inbox om vanuit te versturen",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Voer de sms-tekst in",
      "SMS_COUNTER": "{length}/{limit} tekens, {segments} sms (voordat de variabelen zijn ingevuld)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Automatiseringsregel activeren",
      "DEACTIVATION_TITLE": "Automatiseringsregel deactiveren",
      "ACTIVATION_DESCRIPTION": "Deze actie activeert de automatiseringsregel '{automationName}'. Weet u zeker dat u wilt doorgaan?",
      "DEACTIVATION_DESCRIPTION": "Deze actie zal de automatiseringsregel '{automationName}' deactiveren. Weet u zeker dat u wilt doorgaan?",
      "ACTIVATION_SUCCESFUL": "Automatiseringsregel succesvol geactiveerd",
      "DEACTIVATION_SUCCESFUL": "Automatiseringsregel succesvol gedeactiveerd",
      "ACTIVATION_ERROR": "Automatisering kon niet worden geactiveerd, probeer het later opnieuw",
      "DEACTIVATION_ERROR": "Automatisering kon niet worden gedeactiveerd, probeer het later opnieuw",
      "CONFIRMATION_LABEL": "Ja",
      "CANCEL_LABEL": "Nee"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Kon bijlage niet uploaden, probeer het opnieuw",
      "LABEL_IDLE": "Bijlage uploaden",
      "LABEL_UPLOADING": "Uploaden...",
      "LABEL_UPLOADED": "Succesvol geüpload",
      "LABEL_UPLOAD_FAILED": "Upload mislukt"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Waarde is vereist",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Deze actie werkt alleen als de fase van de regel is ingesteld op 'Voor labelen'.",
      "SKIP_AUTO_LABELING": "Deze actie werkt alleen als de fase van de regel is ingesteld op 'Voor labelen'.",
      "MOVE_CONVERSATION_TO_INBOX": "Alleen e-mail- en webchatgesprekken kunnen naar een e-mailinbox worden verplaatst, en een webchat alleen als het contact een e-mailadres heeft. Anders blijft het gesprek waar het is en wordt in plaats daarvan een privénotitie toegevoegd.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Start een nieuw gesprek met het contact in de geselecteerde e-mailinbox, stuurt het bericht per e-mail en markeert het gesprek als opgelost. Dit gebeurt elke keer dat de regel wordt uitgevoerd. Als het contact geen e-mailadres heeft, wordt er niets verstuurd en wordt in plaats daarvan een privénotitie toegevoegd.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Start een nieuw gesprek met het contact in de geselecteerde sms-inbox, stuurt het bericht per sms en markeert het gesprek als opgelost. Dit gebeurt elke keer dat de regel wordt uitgevoerd. Het bericht is platte tekst zonder bijlagen. Als het contact geen telefoonnummer heeft, wordt er niets verstuurd en wordt in plaats daarvan een privénotitie toegevoegd."
    },
    "NOTICES": {
      "AI_PROMPT": "Elke afzonderlijke beoordeling wordt in rekening gebracht.",
      "INCOMING_MESSAGES_COUNT": "Dit verwijst naar het aantal inkomende berichten in het gesprek.",
      "OUTGOING_MESSAGES_COUNT": "Dit verwijst naar het aantal uitgaande berichten in het gesprek."
    },
    "PHASE": {
      "BEFORE_LABELING": "Voor labelen",
      "AFTER_LABELING": "Na labelen"
    },
    "NONE_OPTION": "Geen",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Inkomend bericht",
      "OUTGOING": "Uitgaand bericht",
      "PRIVATE": "Privénotitie",
      "AI_SUMMARY": "AI-samenvatting"
    },
    "YES_NO_VALUES": {
      "YES": "Ja",
      "NO": "Nee"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Instagram Direct-bericht",
      "FACEBOOK_COMMENT": "Facebook-reactie"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Gesprek aangemaakt",
      "CONVERSATION_UPDATED": "Gesprek bijgewerkt",
      "MESSAGE_CREATED": "Bericht aangemaakt",
      "CONVERSATION_OPENED": "Gesprek geopend",
      "CONVERSATION_RESOLVED": "Gesprek opgelost",
      "PHONE_CALL_FINISHED": "Oproep beëindigd"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Toewijzen aan agent",
      "ASSIGN_TEAM": "Wijs een team toe",
      "ADD_LABEL": "Voeg een label toe",
      "REMOVE_LABEL": "Verwijder een label",
      "SEND_EMAIL_TO_TEAM": "Verstuur een e-mail naar team",
      "SEND_EMAIL_TRANSCRIPT": "Verstuur een e-mailtranscript",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Verstuur een gedetailleerd e-mailtranscript",
      "MUTE_CONVERSATION": "Gesprek dempen",
      "SNOOZE_CONVERSATION": "Gesprek snoozen",
      "RESOLVE_CONVERSATION": "Gesprek oplossen",
      "OPEN_CONVERSATION": "Gesprek openen",
      "SEND_WEBHOOK_EVENT": "Verstuur webhook-gebeurtenis",
      "SEND_ATTACHMENT": "Bijlage versturen",
      "SEND_MESSAGE": "Verstuur een bericht",
      "ADD_NOTE": "Voeg een notitie toe",
      "CHANGE_PRIORITY": "Prioriteit wijzigen",
      "ADD_SLA": "SLA toevoegen",
      "SKIP_AUTO_PRIORITY": "Automatische prioriteit overslaan",
      "SKIP_AUTO_LABELING": "Automatisch labelen overslaan",
      "AUTO_TRANSLATE": "Bericht vertalen",
      "AUTO_TRANSLATE_CONVERSATION": "Gesprek vertalen",
      "MOVE_CONVERSATION_TO_INBOX": "Gesprek naar inbox verplaatsen",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Bericht versturen in een nieuw gesprek",
      "SEND_SMS_IN_NEW_CONVERSATION": "Sms versturen in een nieuw gesprek",
      "STOP_PROCESSING_RULES": "Stop verwerking van regels"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI-filter",
      "MESSAGE_TYPE": "Berichttype",
      "MESSAGE_CONTAINS": "Berichtinhoud",
      "EMAIL": "Contact-e-mail",
      "INBOX": "Inbox",
      "CHANNEL_TYPE": "Inboxtype",
      "CONVERSATION_LANGUAGE": "Taal van het gesprek",
      "PHONE_NUMBER": "Telefoonnummer",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Browsertaal",
      "MAIL_SUBJECT": "E-mailonderwerp",
      "COUNTRY_NAME": "Land",
      "MARKETPLACE_COUNTRY": "Land van marktplaats",
      "REFERER_LINK": "Verwijzende link",
      "ASSIGNEE_NAME": "Toegewezen aan",
      "TEAM_NAME": "Team",
      "PRIORITY": "Prioriteit",
      "CALL_DIRECTION": "Gespreksrichting",
      "MISSED_CALL": "Gemiste oproep",
      "MISSED_CALL_COUNT": "Aantal gemiste oproepen",
      "MESSAGE_SOURCE_TYPE": "Berichtbrontype",
      "INCOMING_MESSAGE_COUNT": "Aantal inkomende berichten",
      "OUTGOING_MESSAGE_COUNT": "Aantal uitgaande berichten",
      "LABEL": "Label",
      "EMAIL_RECIPIENTS": "E-mailontvanger",
      "EMAIL_AUTO_REPLY": "E-mail is een automatisch antwoord",
      "ATTACHMENT_EXTENSION": "Extensie van bijlage",
      "EXTENSION": "Gebelde extensie",
      "WORKING_HOURS": "Binnen werktijden",
      "AGENT_REPLIED": "Medewerker heeft gereageerd sinds de statuswijziging"
    },
    "WAIT": {
      "RUN_LABEL": "Acties uitvoeren",
      "INSTANT": "Bij gebeurtenis",
      "DELAYED": "Vertraagd",
      "TRIGGER_LABEL": "Wachten tot",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Een gesprek blijft in een status",
        "CUSTOMER_UNRESPONSIVE": "De klant antwoordt een agent niet",
        "AGENT_UNRESPONSIVE": "De klant krijgt geen antwoord van een agent"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Open",
        "PENDING": "In afwachting",
        "SNOOZED": "Uitgesteld",
        "RESOLVED": "Opgelost"
      },
      "DELAY_LABEL": "Wachttijd",
      "DELAY_ERROR": "Voer een wachttijd in tussen 1 minuut en 30 dagen",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} u",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "De acties worden uitgevoerd wanneer een gesprek {duration} de status {status} heeft. Een statuswijziging daarvoor annuleert ze. Labels, werktijden en reacties van medewerkers worden gecontroleerd wanneer de wachttijd afloopt.",
        "CUSTOMER_UNRESPONSIVE": "De acties worden uitgevoerd wanneer de klant {duration} niet heeft geantwoord op het bericht van een agent. Een antwoord van de klant annuleert ze; een nieuw bericht van de agent start de wachttijd opnieuw.",
        "AGENT_UNRESPONSIVE": "De acties worden uitgevoerd wanneer de klant {duration} heeft gewacht zonder antwoord van een agent. Een antwoord van de agent annuleert ze."
      }
    }
  }
}
